/* @flow */

import avatarSizes from './setting/avatarSizes';
import { aaDarkGrey } from '@braindate/ui/lib/token/palette';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    maxWidth: ({ variant }: ThemeFunction<{ variant: string }>) =>
      avatarSizes[variant],
    width: '100%',
    maxHeight: ({ variant }: ThemeFunction<{ variant: string }>) =>
      avatarSizes[variant],
    height: '100%',

    backgroundColor: aaDarkGrey,
    borderRadius: '50%',
    borderColor: ({ theme }: ThemeFunction) => theme.accentColor,
    borderWidth: 2,
    aspectRatio: '1 / 1',
  },
};
